import { SurveyCreator } from 'survey-creator-react';
import CustomWidget from 'vl-md/src/CustomSurvey/customWidgets/CustomWidget';
import { JsonObject } from 'survey-core';

/** Renders custom navigation buttons for the survey such as next, previous, complete, etc. */
const CustomizeSurveyNavigation = (surveyCreator?: SurveyCreator) => {
  const activatedByChangeHandler = () => {
    // we do not need to check activatedBy parameter, since we will use our widget for customType only
    // We are creating a new class and derived it from text question type. It means that text model (properties and fuctions) will be available to us
    JsonObject.metaData.addClass('navigation', [], null, 'html');
    JsonObject.metaData.addProperties('navigation', [
      {
        name: 'navType',
        choices: ['Next', 'Previous', 'Complete'],
        default: 'Next',
        category: 'general',
        visibleIndex: 2
      },
      {
        name: 'buttonText',
        default: '',
        category: 'general',
        visibleIndex: 10
      }
    ]);
  };

  const afterRenderHandler = (question, el) => {
    const message = el.getElementsByTagName('div')[0];
    message.innerHTML = question.html;
    const newButton = document.createElement('button');
    let navButton = el.getElementsByTagName('button')[0];
    if (!navButton) {
      navButton = newButton;
      el.appendChild(navButton);
    }
    navButton.classList.add('sd-btn');
    navButton.innerText = question.buttonText ? question.buttonText : question.navType;
    navButton.onclick = () => {
      const { navType, survey } = question;
      switch (navType) {
        case 'Next':
          survey.nextPage();
          break;
        case 'Previous':
          survey.prevPage();
          break;
        case 'Complete':
          survey.completeLastPage();
          break;
        default:
          break;
      }
      question.value = true;
    };
    const onValueChangedCallback = () => {
      message.innerHTML = question.html || '';
      navButton.innerText = question.buttonText || question.navType;
    };
    const onReadOnlyChangedCallback = () => {
      if (question.isReadOnly) {
        message.setAttribute('disabled', 'disabled');
        if (question.navType === 'Complete') {
          navButton.setAttribute('disabled', 'disabled');
        } else {
          navButton.removeAttribute('disabled');
        }
      } else {
        message.removeAttribute('disabled');
        navButton.removeAttribute('disabled');
      }
    };
    question.readOnlyChangedCallback = onReadOnlyChangedCallback;
    question.onPropertyValueChanged = onValueChangedCallback;
    onValueChangedCallback();
    onReadOnlyChangedCallback();
  };

  const widgetName = 'navigation';
  const widgetTitle = 'Navigation';
  const widgetIconName = 'hbs-navigation-class';
  const htmlTemplate = '<div data-testid="customized-navigation-component"><div></div><button></button></div>';

  CustomWidget({
    name: widgetName,
    title: widgetTitle,
    iconName: widgetIconName,
    activatedByChangeHandler,
    htmlTemplate,
    afterRenderHandler,
    surveyCreator
  });
};

export default CustomizeSurveyNavigation;
